// Splits a string on a separator, where if no items are found in the collection, the it returns is empty.
export const splitString = (text: string, separator: string): string[] => {
  return text.split(separator).filter((s) => s !== '');
};
